import { render, staticRenderFns } from "./_FollowUp.vue?vue&type=template&id=5a9cc787&scoped=true&"
import script from "./_FollowUp.vue?vue&type=script&lang=js&"
export * from "./_FollowUp.vue?vue&type=script&lang=js&"
import style0 from "./_FollowUp.vue?vue&type=style&index=0&id=5a9cc787&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9cc787",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMain } from 'vuetify/lib/components/VMain';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VCol,VDataTable,VIcon,VMain,VPagination,VRow})
